import { render, staticRenderFns } from "./ChatBody.vue?vue&type=template&id=6165f4d3&scoped=true"
import script from "./ChatBody.vue?vue&type=script&lang=js"
export * from "./ChatBody.vue?vue&type=script&lang=js"
import style0 from "./ChatBody.vue?vue&type=style&index=0&id=6165f4d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165f4d3",
  null
  
)

export default component.exports